/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import MessageContentSend, {
  MessageContentProps,
} from '@sendbird/uikit-react/ui/MessageContent';

import { broadcastedMessageType, userIdSelector } from '@pharmaplan/common';

import { useAppSelector } from '../../../../hooks/useAppSelector';
import useAdmin from '../../../../hooks/useAdmin';

import SenderProfile from './SenderProfile';
import MessageStatus from './MessageStatus';
import SenderTitle from './SenderTitle';

const MessageContent = (props: MessageContentProps) => {
  const myUserId = useAppSelector(userIdSelector);
  const { isAdmin } = useAdmin();

  const { message } = props ?? {};
  const { sender, customType } = (message as { sender: { userId: string }; customType?: string }) ?? {};
  const { userId } = sender ?? {};

  const isSenderMe = userId === myUserId;
  const isBroadcast = customType === broadcastedMessageType;
  const showBroadcastTitle = !isSenderMe && isBroadcast && !isAdmin;

  let RenderSenderTitle;
  let RenderSenderProfile;

  if (showBroadcastTitle) {
    RenderSenderTitle = SenderTitle;
  }

  if (!isSenderMe) {
    RenderSenderProfile = SenderProfile;
  }

  return (
    <MessageContentSend
      {...props}
      renderSenderProfile={RenderSenderProfile}
      renderMessageHeader={RenderSenderTitle}
      renderMessageStatus={() =>
        (
          <MessageStatus message={props.message} channel={props.channel} />
        )}
    />
  );
};

export default MessageContent;
